import { Slide, SlideProps, Snackbar } from "@biggeo/bg-ui";
import { Severity, Toast } from "@biggeo/bg-ui/lab";
import React from "react";
import { useDispatch } from "react-redux";
import { compose } from "redux";
import { useToaster } from "./redux/hooks";
import { toasterActions } from "./redux/model";

export interface ToastModel {
    readonly title?: string;
    readonly message?: string;
    readonly severity?: Severity;
    readonly open: boolean;
    readonly autoHideDuration: number | null;
    readonly additionalAction?: {
        readonly ctaText: string;
        readonly onClick: () => void;
    };
}

const ToastContainer = () => {
    const dispatch = useDispatch();
    const setOpen = compose(dispatch, toasterActions.setOpen);
    const toast = useToaster();

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Snackbar
            open={toast.open}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            onClose={(_e, reason) => {
                if (reason === "clickaway" || toast.autoHideDuration === null) {
                    return;
                }
                handleClose();
            }}
            TransitionComponent={(props: SlideProps) => (
                <Slide direction="up" {...props} />
            )}
            autoHideDuration={toast.autoHideDuration}
            sx={{ display: toast.open ? "block" : "none" }}
        >
            <Toast
                title={toast.title}
                onClose={handleClose}
                ctaText={
                    toast.additionalAction
                        ? toast.additionalAction.ctaText
                        : undefined
                }
                onClick={
                    toast.additionalAction
                        ? toast.additionalAction.onClick
                        : undefined
                }
                severity={toast.severity}
            />
        </Snackbar>
    );
};

export default React.memo(ToastContainer);
